module.exports = __webpack_public_path__ + "static/img/ktb.6003b833.svg";